module.exports = __webpack_public_path__ + "static/img/zhuapaijilu2.9ac425a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/blue/zhuapaijilu2.png
// module id = CuMR
// module chunks = 24